/**
 * Utility functions for displaying user roles consistently across the application
 */

export const formatRoleForDisplay = (role: string | undefined | null): string => {
  if (!role) return 'Player';
  
  const roleMap: Record<string, string> = {
    'player': 'Player',
    'coach': 'Coach',
    'team-owner': 'Team Owner',
    'venue': 'Venue Manager',
    'creative': 'Creative',
    'support': 'Support/Score Keeper',
    'scorekeeper': 'Score Keeper',
    'fan': 'Fan',
    'parent': 'Parent',
    'admin': 'Administrator',
    'agent': 'Agent',
  };
  
  const lowerRole = role.toLowerCase();
  return roleMap[lowerRole] || role.charAt(0).toUpperCase() + role.slice(1);
};

export const getRoleBadgeColor = (role: string | undefined | null): string => {
  if (!role) return 'text-gray-400';
  
  const colorMap: Record<string, string> = {
    'admin': 'text-red-400',
    'coach': 'text-blue-400',
    'team-owner': 'text-purple-400',
    'venue': 'text-amber-400',
    'agent': 'text-emerald-400',
    'parent': 'text-pink-400',
  };
  
  return colorMap[role.toLowerCase()] || 'text-gray-400';
};
